
import { Options, Vue, prop } from "vue-class-component";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import { HandoverV2Detail } from "@/domain/entities/HandoverV2";

class Props {
  rows = prop<HandoverV2Detail[]>({ default: () => [], type: Array });
  isLoading = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  emits: ["request", "update:pagination"]
})
class ScanResultsTable extends Vue.with(Props) {
  formatWeight(value: number): string {
    return formatByCountry(value, { type: "weight", suffix: " kg" });
  }

  formatQuantity(value: number): string {
    return formatByCountry(value, { type: "quantity" });
  }

  onRequest(): void {
    this.$emit("request");
  }

  get columns(): any[] {
    return [
      {
        name: "No",
        slotName: "no",
        styleHead: "w-12 text-left font-bold z-90",
        render: (_item: HandoverV2Detail, index: number) =>
          this.rows.length - index
      },
      {
        name: this.$t("handoverV2.update.table.sttNo"),
        slotName: "no-stt-shipment",
        "custom-slot": true,
        styleHead: "w-56 text-left"
      },
      {
        name: this.$t("handoverV2.update.common.product"),
        slotName: "product",
        "custom-slot": true,
        styleHead: "w-48 text-left"
      },
      {
        name: this.$t("handoverV2.update.common.commodity"),
        slotName: "commodity",
        "custom-slot": true,
        styleHead: "w-40 text-left"
      },
      {
        name: this.$t("handoverV2.update.table.piece"),
        slotName: "piece",
        "custom-slot": true,
        styleHead: "w-24 text-left"
      },
      {
        name: this.$t("handoverV2.update.table.grossWeight"),
        slotName: "gross-weight",
        "custom-slot": true,
        styleHead: "w-40 text-left"
      },
      {
        name: this.$t("handoverV2.update.table.volumeWeight"),
        slotName: "volume-weight",
        "custom-slot": true,
        styleHead: "w-40 text-left"
      },
      {
        name: this.$t("handoverV2.update.table.action"),
        key: "actionable_column",
        styleHead: "w-20 text-left",
        columnKey: "cargo-config-v2-actions",
        showButton: () => true
      }
    ];
  }

  get customButton() {
    return {
      flat: true,
      iconV2: true,
      iconLeft: "delete",
      sizeIcon: "w-4",
      iconGroupHoverColor: "text-red-lp-2000",
      textColor: "red-lp-2000",
      dense: true,
      clickFunction: (item: HandoverV2Detail) => {
        this.$emit("delete", item);
      }
    };
  }
}

export default ScanResultsTable;
